module.exports = __webpack_public_path__ + "static/media/03_Mascotte_froid.e6fd16a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/03_Mascotte_froid.svg
// module id = 759
// module chunks = 0